import { Box, Typography, Button } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MainContainer } from "../../../components/container/MainContainer";
import { PageTitleContainer } from "../../../components/container/PageTitleContainer";
import SegmentedTabs from "../../../components/tabs/SegmentedTabs";
import ArchiveGrid from "./ArchiveGrid";
const Archive = () => {
  const { t } = useTranslation();
  const all = { label: "All", value: null };
  const product = { label: "Product", value: "product" };
  const project = { label: "Project", value: "project" };
  const building = { label: "Building", value: "building" };
  const supply_chain = { label: "Supply Chain", value: "supply_chain" };
  const structure = { label: "Organization", value: "structure" };
  const tabs = [all, product, project, building, supply_chain, structure];
  const [selectedTab, setSelectedTab] = useState(all.value);
  const [count, setCount] = useState(0);

  return (
    <MainContainer>
      <PageTitleContainer>
        <Box>
          <Box>
            <Typography variant="Page Title">
              {t("Intra Company Library")} ({count})
            </Typography>
          </Box>
          <Box>
            <Typography variant="Page Subtitle">{t("Intra Company Library")}</Typography>
          </Box>
        </Box>
      </PageTitleContainer>
      <Box>
        <SegmentedTabs options={tabs} selected={selectedTab} setSelected={setSelectedTab} />
      </Box>
      <Box sx={{ paddingY: 1 }} />
      <Box>
        <ArchiveGrid type={selectedTab} onCountChange={setCount} />
      </Box>
    </MainContainer>
  );
};
export default Archive;
